export default __webpack_public_path__ + "static/media/sports.3e1a8951.png";